module.exports = __webpack_public_path__ + "static/media/Admin.98e05c02.svg";